<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="false"
    :full-screen="true"
  >
    <template slot="header">
      <span
        v-if="item"
        style="font-size: 30px; font-weight: 500; color: #000000;"
      >Job: {{ item.wo_number }} - {{ item.project }}; {{ item.project_floor }}</span>
      <v-col class="text-end">
        <span style="font-size: 30px; font-weight: 500; color: #000000;">Stage: {{ stageName }}</span>
      </v-col>
      <v-col class="text-end">
        <span style="font-size: 30px; font-weight: 500; color: #000000;">Total {{ isWindows ? 'Windows' : 'Doors' }}: {{ totalWindowsOrDoors }}</span>
      </v-col>
      <v-col v-if="isWindows || isDoors" class="text-end">
        <span style="font-size: 30px; font-weight: 500; color: #000000;">Total Components: {{ totalComponents }}</span>
      </v-col>
    </template>
    <template slot="body">
      <v-row>
        <v-col>
          <v-card
            elevation="0"
            outlined
          >
            <v-data-table
              :headers="headers"
              :items="items"
              hide-default-footer
              :items-per-page="-1"
              :loading="loading"
              :show-expand="isWindows || isDoors"
              :expanded="expandedItems"
              dense
            >
              <template #[`item.data-table-expand`]="{ item }">
                <tr>
                  <td>
                    <v-icon
                      v-if="
                        item.frames &&
                          item.frames.length > 0
                      "
                      style="font-size: 22px !important"
                      @click="toggleExpand(item)"
                    >
                      {{
                        expandedItems.includes(item)
                          ? 'mdi-chevron-down'
                          : 'mdi-chevron-up'
                      }}
                    </v-icon>
                  </td>
                </tr>
              </template>
              <template #[`item.progress`]="{ item }">
                <span
                  v-if="(item.type_id === finishedGoodCommercialTypeIdWindow || item.type_id === finishedGoodCommercialTypeIdDoor) && item.frames && item.frames.length > 0"
                  style="color: rgb(255, 152, 0);"
                  :style="{
                    color: item.progress && item.progress === 100 ? 'green' : '',
                  }"
                >
                  {{ `${item.frames_passed_stage_count}/${item.frame_count}` }}
                </span>
              </template>
              <template #[`item.frame_count`]="{ item }">
                <span>
                  {{ item.frame_count ? item.frame_count : '-' }}
                </span>
              </template>
              <template #[`item.location`]="{ item }">
                <span>
                  {{ item.location ? item.location.name : '-' }}
                </span>
              </template>
              <template #[`item.width`]="{ item }">
                <span>
                  {{ item && (item.type_id === finishedGoodCommercialTypeIdWindow || item.type_id === finishedGoodCommercialTypeIdDoor) && item.width ? item.width : '-' }}
                </span>
              </template>
              <template #[`item.height`]="{ item }">
                <span>
                  {{ item && (item.type_id === finishedGoodCommercialTypeIdWindow || item.type_id === finishedGoodCommercialTypeIdDoor) && item.height ? item.height : '-' }}
                </span>
              </template>
              <template #[`item.sqft`]="{ item }">
                <span>
                  {{ item && (item.type_id === finishedGoodCommercialTypeIdWindow || item.type_id === finishedGoodCommercialTypeIdDoor) && item.sqft ? item.sqft : '-' }}
                </span>
              </template>
              <template #[`item.length`]="{ item }">
                <span>
                  {{ item && item.type_id === finishedGoodCommercialTypeIdFrame && (item.width || item.height) ? (item.width || item.height) : '-' }}
                </span>
              </template>
              <template #[`item.status`]="{ item }">
                <v-tooltip
                  bottom
                  color="black"
                >
                  <template #activator="{ on }">
                    <v-chip
                      v-if="item && item.status"
                      small
                      :color="item.status.color ? item.status.color : '#000000'"
                      text-color="white"
                      @mouseover="getHistory(item)"
                      v-on="on"
                    >
                      {{ item.status.name }}
                    </v-chip>
                  </template>

                  <div
                    style="width: 400px; flex-direction: column; gap: 12px;"
                    class="pt-3 d-flex"
                  >
                    <div
                      v-for="history in finishedGoodCommercialHistories"
                      :key="history.id"
                      class="d-flex align-center"
                    >
                      <div style="width: 50%">
                        <v-chip
                          v-if="history && history.status"
                          small
                          :color="history.status.color ? history.status.color : '#000000'"
                          text-color="white"
                        >
                          {{ history.status.name }}
                        </v-chip>
                      </div>
                      <span> At: {{ history.created_at }}</span>
                    </div>
                  </div>
                </v-tooltip>
              </template>
              <template #[`item.department`]="{ item }">
                <span>
                  {{ item.department ? item.department.name : '' }}
                </span>
              </template>
              <template #[`item.quarantine_remake_reason`]="{ item }">
                <span>
                  {{ item.quarantine_reason ? item.quarantine_reason.name : '' }} - {{ item.quarantine_sub_reason ? item.quarantine_sub_reason.name : '' }}; {{ item.quarantined_at ? item.quarantined_at : '' }}
                </span>
              </template>
              <template #[`item.note`]="{ item }">
                <div style="max-width: 250px;">
                  <span
                    v-if="item.notes && item.notes.length > 0"
                    style="color: rgb(255, 152, 0);"
                  >
                    <v-btn
                      icon
                      small
                      @click="openNoteForm(item.id)"
                    >
                      <v-icon
                        small
                      >
                        mdi-eye
                      </v-icon>
                    </v-btn>
                    <span>{{ item.notes && item.notes.length > 0 ? item.notes[0].text : '' }}</span>
                  </span>
                  <v-btn
                    v-else
                    color="primary"
                    small
                    icon
                    @click="openNoteForm(item.id)"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </div>
              </template>
              <template #expanded-item="{ headers, item }">
                <td
                  class="px-2 py-2"
                  :colspan="headers.length"
                >
                  <v-data-table
                    v-if="
                      item.frames &&
                        item.frames.length > 0 &&
                        item.frames
                    "
                    id="sub-table"
                    :colspan="headers.length"
                    :headers="subHeaders"
                    :items="item.frames"
                    hide-default-footer
                    :items-per-page="-1"
                    dense
                  >
                    <template #[`item.aluminum_die`]="{ item }">
                      <span>
                        {{ item.aluminum_die ? item.aluminum_die.code : '-' }}
                      </span>
                    </template>
                    <template #[`item.int_color`]="{ item }">
                      <span>
                        {{ item.int_color ? item.int_color.code : '-' }}
                      </span>
                    </template>
                    <template #[`item.ext_color`]="{ item }">
                      <span>
                        {{ item.ext_color ? item.ext_color.code : '-' }}
                      </span>
                    </template>
                    <template #[`item.type`]="{ item }">
                      <span>
                        {{ item.type ? item.type.name : '-' }}
                      </span>
                    </template>
                    <template #[`item.length`]="{ item }">
                      <span>
                        {{ item.width ? item.width : item.height ? item.height : '-' }}
                      </span>
                    </template>
                    <template #[`item.location`]="{ item }">
                      <span>
                        {{ item.location ? item.location.name : '-' }}
                      </span>
                    </template>
                    <template #[`item.inventory_location`]="{ item }">
                      <span>
                        {{ item.inventory_location ? item.inventory_location.name : '-' }}
                      </span>
                    </template>
                    <template #[`item.status`]="{ item }">
                      <v-tooltip
                        bottom
                        color="black"
                      >
                        <template #activator="{ on }">
                          <v-chip
                            v-if="item && item.status"
                            small
                            :color="item.status.color ? item.status.color : '#000000'"
                            text-color="white"
                            @mouseover="getHistory(item)"
                            v-on="on"
                          >
                            {{ item.status.name }}
                          </v-chip>
                        </template>

                        <div
                          style="width: 400px; flex-direction: column; gap: 12px;"
                          class="pt-3 d-flex"
                        >
                          <div
                            v-for="history in finishedGoodCommercialHistories"
                            :key="history.id"
                            class="d-flex align-center"
                          >
                            <div style="width: 50%">
                              <v-chip
                                v-if="history && history.status"
                                small
                                :color="history.status.color ? history.status.color : '#000000'"
                                text-color="white"
                              >
                                {{ history.status.name }}
                              </v-chip>
                            </div>
                            <span> At: {{ history.created_at }}</span>
                          </div>
                        </div>
                      </v-tooltip>
                    </template>
                    <template #[`item.note`]="{ item }">
                      <div style="max-width: 250px;">
                        <span
                          v-if="item.notes && item.notes.length > 0"
                          style="color: rgb(255, 152, 0);"
                        >
                          <v-btn
                            icon
                            small
                            @click="openNoteForm(item.id)"
                          >
                            <v-icon
                              small
                            >
                              mdi-eye
                            </v-icon>
                          </v-btn>
                          <span>{{ item.notes && item.notes.length > 0 ? item.notes[0].text : '' }}</span>
                        </span>
                        <v-btn
                          v-else
                          color="primary"
                          small
                          icon
                          @click="openNoteForm(item.id)"
                        >
                          <v-icon small>
                            mdi-pencil
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <NoteForm
        ref="noteForm"
        @success="get(item, statusId)"
      />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NoteForm from '@/components/forms/notes/NoteForm.vue';

export default {
  components: {
    NoteForm,
  },
  props: {

  },
  data: () => ({
    items: [],
    expandedItems: [],
    loading: false,
    item: null,
    stageName: '',
    stageOrder: null,

    noteTypeIdFinishedGoodCommercial: 12,

    finishedGoodCommercialTypeIdWindow: 1,
    finishedGoodCommercialTypeIdDoor: 2,
    finishedGoodCommercialTypeIdFrame: 3,

    finishedGoodCommercialStatusIdFinishedGood: 8,
    finishedGoodCommercialStatusIdShipped: 9,
    finishedGoodCommercialStatusIdReceived: 10,
    finishedGoodCommercialStatusIdReturned: 12,
    finishedGoodCommercialStatusIdQuarantined: 13,

    stageOrderFinishedGoods: 11,

    jobSubClassIdCommWindows: 5,
    jobSubClassIdCommDoors: 7,

    //these are actually stage progressions
    materialAvailableId: 1,
    cuttingBeforePaintId: 2,
    fabricationId: 3,
    assemblyBeforePaintId: 4,
    weldingId: 5,
    shippingForPaintId: 6,
    hardwareId: 7,
    cutId: 8,
    bracketsId: 9,
    assembledId: 10,
    finishedGoodId: 11,
    bundledId: 12,
    onSkidId: 13,
    loadedId: 14,
    shippedId: 15,
    receivedId: 16,
    returnedId: 17,
    quarantinedId: 18,
    
    statusId: null,
    finishedGoodCommercialHistories: [],
    loadingHistory: false,

    subHeaders: [
      { text: 'Serial#', value: 'id' },
      { text: 'Tag Id', value: 'tag_id' },
      { text: 'Tag Number', value: 'tag_number' },
      { text: 'Work Order', value: 'work_order' },
      { text: 'Reference', value: 'floor_number' },
      { text: 'Aluminum Die', value: 'aluminum_die' },
      { text: 'Int Color', value: 'int_color' },
      { text: 'Ext Color', value: 'ext_color' },
      { text: 'Type', value: 'type' },
      { text: 'Length', value: 'length' },
      { text: 'Location', value: 'location' },
      { text: 'Status', value: 'status', align: 'center' },
      { text: 'Note', value: 'note', align: 'center' },
    ]
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
    isWindows() {
      if (!this.item) return false;
      return this.item.sub_class_id === this.jobSubClassIdCommWindows;
    },
    isDoors() {
      if (!this.item) return false;
      return this.item.sub_class_id === this.jobSubClassIdCommDoors;
    },
    totalWindowsOrDoors() {
      if (!this.items) return 0;
      return this.items.filter(fg =>fg.type_id === this.finishedGoodCommercialTypeIdWindow || fg.type_id === this.finishedGoodCommercialTypeIdDoor).length;
    },
    totalComponents() {
      if (!this.item) return 0;
      // if (this.item.sub_class_id !== this.jobSubClassIdCommWindows) return 0;
      if (!this.items) return 0;
      let frameCount = 0;
      this.items.forEach((fg) => {
        frameCount += fg.frames ? fg.frames.length : 0;
      });
      this.items.forEach((fg) => {
        frameCount += (fg.type_id === this.finishedGoodCommercialTypeIdFrame || fg.type_id === this.finishedGoodCommercialTypeIdSlab) ? 1 : 0;
      });
      return frameCount;
    },
    headers() {
      const returnHeaders = [];
      if((this.isWindows || this.isDoors) && this.statusId !== this.finishedGoodCommercialStatusIdReturned) {
        returnHeaders.push({ text: 'Progress', value: 'progress', align: 'center', width: '5%' });
      }
      if(this.isWindows || this.isDoors) {
        returnHeaders.push({ text: 'Total Components', value: 'frame_count', align: 'center', width: '5%' });
      }
      returnHeaders.push({ text: 'Serial#', value: 'id' });
      returnHeaders.push({ text: 'Tag Id', value: 'tag_id' });
      returnHeaders.push({ text: 'Tag Number', value: 'tag_number' });
      returnHeaders.push({ text: 'Work Order', value: 'work_order' });
      returnHeaders.push({ text: 'Reference', value: 'floor_number' });
      returnHeaders.push({ text: 'Width', value: 'width' });
      returnHeaders.push({ text: 'Height', value: 'height' });
      returnHeaders.push({ text: 'Sqft', value: 'sqft' });
      returnHeaders.push({ text: 'Length', value: 'length' });

      if (this.stageOrder > this.stageOrderFinishedGoods) {
        returnHeaders.push({ text: 'Location', value: 'location' });
      }

      if (this.statusId === this.finishedGoodCommercialStatusIdReturned) {
        returnHeaders.push({
          text: 'Return Reason', value: 'return_reason',
        });
      }

      if (this.statusId === this.finishedGoodCommercialStatusIdQuarantined) {
        returnHeaders.push({
          text: 'Department', value: 'department',
        });
      }
      if (this.statusId === this.finishedGoodCommercialStatusIdQuarantined) {
        returnHeaders.push({
          text: 'Quarantine Reasons', value: 'quarantine_remake_reason',
        });
      }

      returnHeaders.push({ text: 'Status', value: 'status', align: 'center' });
      returnHeaders.push({ text: 'Note', value: 'note', align: 'center' });

      return returnHeaders;
    },
  },
  watch: {

  },
  created() {
  },
  methods: {

    async get(item) {
      this.expandedItems = [];
      this.loading = true;
      this.items = [];
      // set type_id to windows if commercial schedule job_sub_class_id equals
      let is_include_frames = false;
      if (item.sub_class_id === this.jobSubClassIdCommWindows) {
        item.type_id = this.finishedGoodCommercialTypeIdWindow;
        is_include_frames = true;
      } else if (item.sub_class_id === this.jobSubClassIdCommDoors) {
        item.type_id = this.finishedGoodCommercialTypeIdDoor;
      } else {
        this.$bus.$emit('showError', 'Unknown Job Sub Class for Curtainwall Schedule Finished Goods');
        this.loading = false;
        this.$refs.dialogBox.close();
        return;
      }
      const submitModel = {
        filters: {
          commercial_schedule_id: item.id,
          status_id: this.statusId,
          stage_order: this.stageOrder,
          // type_id: item.type_id,
        },
        includes: {
          // is_include_frames: is_include_frames,
        }
      };
      const res = await this.$api.finishedGoodCommercial.read(submitModel, null, 'read-from-stage');
      this.loading = false;
      if (!res) return;
      this.items = res;
    },

    async getHistory(item) {
      if (this.loadingHistory) return;
      this.loadingHistory = true;
      const submitModel = {
        filters: {
          finished_good_commercial_id: item.id,
        },
      };

      const res = await this.$api.finishedGoodCommercialHistory.read(submitModel);

      this.loadingHistory = false;
      if (!res || !res.data || res.data.length === 0) {
        this.finishedGoodCommercialHistories = [];
        return;
      }

      this.finishedGoodCommercialHistories = res.data;
    },

    open(item, statusId, stageName, stageOrder) {
      this.item = item;
      this.statusId = statusId;
      this.stageName = stageName;
      this.stageOrder = stageOrder;
      this.get(item);
      this.$refs.dialogBox.open();
    },

    openNoteForm(itemId) {
      this.$refs.noteForm.open(itemId, this.noteTypeIdFinishedGoodCommercial);
    },

    toggleExpand(item) {
      if (!item) return;
      const index = this.expandedItems.indexOf(item);
      if (index > -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandedItems.push(item);
      }
    },

    // calculateProgress(item) {
    //   if (!item) return '0%';
    //   if (!item.frames || item.frames.length === 0) return '100%';
    //   let progress = 0;
    //   let totalFrames = item.frames.length;
    //   let framesThatPassTheCurrentStage = 0;
    //   const currentStage = this.stageOrder;
    //   item.frames.forEach((frame) => {
    //     if (frame.status && frame.status.stage_order >= currentStage) {
    //       framesThatPassTheCurrentStage += 1;
    //     }
    //   });
    //   progress = Math.round((framesThatPassTheCurrentStage / totalFrames) * 100);
    //   return `${progress}%`;
    // }
  },
};
</script>
<style scoped>
::v-deep
  #sub-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  background-color: #5f5f5f;
}
</style>
